<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="DETALLES GENERALES" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row class="mb-4">
              <ValidationProvider rules="required" name="Nombre" style="width: 100%" v-slot="{ valid, errors }">
                <Label label="Nombre" :blank="submitalForm.title" show-reset @reset="submitalForm.title = null" />
                <b-input-group size="lg">
                  <b-input
                    v-model="submitalForm.title"
                    type="text"
                    :state="errors[0] ? false : (valid ? true : false)"
                    trim
                    @blur="updateSubmital"
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>
            <b-row class="mb-4">
              <ValidationProvider :rules="{ required: true, numeric: true, min_value: 1 }" name="cantidad" style="width: 100%" v-slot="{ valid, errors }">
                <Label label="Cantidad de puertas idénticas" :blank="submitalForm.quantity" show-reset @reset="submitalForm.quantity = null" />
                <b-input-group size="lg">
                  <b-input
                    v-model.number="submitalForm.quantity"
                    type="number"
                    :state="errors[0] ? false : (valid ? true : false)"
                    min="1"
                    max="100"
                    step="1"
                    @blur="updateSubmital"
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>
            <b-row class="flex-column">
              <Label label="Tipo de fabricación" :blank="form.fabrication_type" />
              <b-form-group>
                <b-radio-group size="lg" v-model="form.fabrication_type" class="ml-4">
                  <b-radio value="Nacional">
                    Nacional
                  </b-radio>
                  <b-radio value="Internacional">
                    Internacional
                  </b-radio>
                </b-radio-group>
              </b-form-group>
            </b-row>
            <b-row class="mb-4">
              <b-form-group class="w-100">
                <template #label>
                  <Label label="Automatismo" :blank="form.automation_type" show-reset @reset="form.automation_type = null" />
                </template>
                <b-select v-model="form.automation_type" :options="automationTypeOptions">
                  <template #first>
                    <b-select-option v-show="!form.automation_type" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row class="mb-4">
              <b-form-group class="w-100">
                <template #label>
                  <Label label="Material de la hoja" :blank="form.leaf_material" show-reset @reset="form.leaf_material = null" />
                </template>
                <b-select
                  v-model="form.leaf_material"
                  :options="leafMaterialOptions"
                  @change="form.door_configuration = null"
                >
                  <template #first>
                    <b-select-option v-show="!form.leaf_material" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>

            <b-row class="mb-4">
              <b-form-group class="w-100">
                <template #label>
                  <Label label="Color del aluminio" :blank="form.aluminum_color" show-reset @reset="form.aluminum_color = null" />
                </template>
                <b-select v-model="form.aluminum_color" :options="aluminumColorOptions">
                  <template #first>
                    <b-select-option v-show="!form.aluminum_color" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row v-if="form.aluminum_color === 'Otro'" class="mb-4">
              <ValidationProvider :rules="{ required: form.aluminum_color_custom }" name="Detalle del color del aluminio" style="width: 100%" v-slot="{ valid, errors }">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Detalle el color del aluminio" :blank="form.aluminum_color_custom" show-reset @reset="form.aluminum_color_custom = null" />
                  </template>
                  <b-textarea v-model="form.aluminum_color_custom" rows="3" trim :state="errors[0] ? false : (valid ? true : false)" />
                </b-form-group>
              </ValidationProvider>
            </b-row>

            <b-row class="mb-4">
              <b-form-group class="w-100">
                <template #label>
                  <Label label="Tipo de vidrio" :blank="form.glass_type" show-reset @reset="form.glass_type = null" />
                </template>
                <b-select
                  v-model="form.glass_type"
                  :options="glassTypeOptions"
                  @change="form.glass_thickness = null"
                >
                  <template #first>
                    <b-select-option v-show="!form.glass_type" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row v-if="form.glass_type" class="mb-4">
              <b-form-group class="w-100">
                <template #label>
                  <Label label="Calibre del vidrio" :blank="form.glass_thickness" show-reset @reset="form.glass_thickness = null" />
                </template>
                <b-select v-model="form.glass_thickness" :options="glassThicknessOptions">
                  <template #first>
                    <b-select-option v-show="!form.glass_thickness" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row v-if="form.glass_thickness === 'otro'" class="mb-4">
              <ValidationProvider :rules="{ required: form.glass_thickness_custom }" name="Detalle el tipo de vidrio" style="width: 100%" v-slot="{ valid, errors }">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Detalle el calibre del vidrio" :blank="form.glass_thickness_custom" show-reset @reset="form.glass_thickness_custom = null" />
                  </template>
                  <b-textarea v-model="form.glass_thickness_custom" rows="3" trim :state="errors[0] ? false : (valid ? true : false)" />
                </b-form-group>
              </ValidationProvider>
            </b-row>

            <b-row class="mb-4">
              <b-col cols="12" lg="6" class="pl-0">
                <Label label="Polarizado" :blank="form.polarized_type" show-reset @reset="form.polarized_type = ''" />
                <b-form-group>
                  <b-radio-group size="lg" v-model="form.polarized_type" stacked class="ml-4">
                    <b-radio value="no">
                      No
                    </b-radio>
                    <b-radio value="si, sin arte">
                      Sí, sin arte
                    </b-radio>
                    <b-radio value="si, con arte">
                      Sí, con arte
                    </b-radio>
                    <b-radio value="si, tipo sandblasting">
                      Sí, tipo sandblasting
                    </b-radio>
                  </b-radio-group>
                </b-form-group>
              </b-col>
              <!-- POLARIZED ATTACHMENT -->
              <b-col v-if="form.polarized_type == 'si, con arte'">
                <Label label="Diseño" :blank="polarizedDesign.id ? true : ''"/>
                <div class="d-flex justify-content-center align-items-center mt-3">
                  <b-button
                    v-if="!polarizedDesign.id"
                    variant="outline-primary"
                    size="sm"
                    class="mt-2"
                    @click="openAttachmentsModal('polarizado')"
                  >
                    <font-awesome-icon :icon="['far', 'file-alt']" size="lg" fixed-width />
                    <span>Adjuntar diseño de Polarizado</span>
                  </b-button>
                  <div v-else class="d-flex justify-content-between align-items-center w-100">
                    <b-link
                      class="text-truncate"
                      @click="handleOnClickAttachment(polarizedDesign)"
                    >
                      <font-awesome-icon :icon="['far', 'file-alt']" fixed-width />
                      <span>{{ polarizedDesign.name }}</span>
                    </b-link>
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      @click="handleFileRemoved(polarizedDesign, 'polarizado')"
                    >
                      <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width />
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row class="mb-4">
              <b-col cols="12" lg="6" class="pl-0">
                <Label label="Sandblasting" :blank="form.sandblasting_type" show-reset @reset="form.sandblasting_type = ''" />
                <b-form-group>
                  <b-radio-group size="lg" v-model="form.sandblasting_type" stacked class="ml-4">
                    <b-radio value="no">
                      No
                    </b-radio>
                    <b-radio value="si, sin arte">
                      Sí, sin arte
                    </b-radio>
                    <b-radio value="si, con arte">
                      Sí, con arte
                    </b-radio>
                  </b-radio-group>
                </b-form-group>
              </b-col>
              <!-- SANDBLASTING ATTACHMENT -->
              <b-col v-if="form.sandblasting_type == 'si, con arte'">
                <Label label="Diseño" :blank="sandBlastingDesign.id ? true : ''"/>
                <div class="d-flex justify-content-center align-items-center mt-3">
                  <b-button
                    v-if="!sandBlastingDesign.id"
                    variant="outline-primary"
                    size="sm"
                    class="mt-2"
                    @click="openAttachmentsModal('sanblasting')"
                  >
                    <font-awesome-icon :icon="['far', 'file-alt']" size="lg" fixed-width />
                    <span>Adjuntar diseño de Sanblasting</span>
                  </b-button>
                  <div v-else class="d-flex justify-content-between align-items-center w-100">
                    <b-link
                      class="text-truncate"
                      @click="handleOnClickAttachment(sandBlastingDesign)"
                    >
                      <font-awesome-icon :icon="['far', 'file-alt']" fixed-width />
                      <span>{{ sandBlastingDesign.name }}</span>
                    </b-link>
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      @click="handleFileRemoved(sandBlastingDesign, 'sanblasting')"
                    >
                      <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width />
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>

            <StepNotes
              :value="form.general_notes"
              @update-form="updateStepNotes"
            />

            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>

    <Modal
      v-if="attachmentsModalShow"
      contentWidth="500px"
      :required=true
      @close="closeAttachmentsModal"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          {{  attachmentsModalTitle }}
        </p>
      </template>
      <template #body>
        <b-row>
          <b-col>
            <AttachmentsUploader
              :allowedFileTypes="['.pdf', '.dwg', '.ai']"
              :maxNumberOfFiles="1"
              :maxFileSize="10485760"
              :useDashboard="true"
              @file-added="handleFileAdded"
              @handle-done-button="closeAttachmentsModal"
            />
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  leafMaterialOptions,
  aluminumColorOptions,
  glassTypeOptions,
  glassThicknessFullOptions,
  automationTypeOptions
} from '../../../../sharedOptions/puertasAutomaticasModule'

import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import Label from '../Label'
import StepNotes from '../StepNotes'
import Modal from '../../../shared/Modal'
import AttachmentsUploader from '../../../shared/AttachmentsUploader'


export default {
  name: 'General',
  components: {
    ConfiguratorStepTitle,
    ValidationObserver,
    ValidationProvider,
    Label,
    StepNotes,
    Modal,
    AttachmentsUploader
  },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      processing: false,
      submitalForm: {
        title: '',
        quantity: 1
      },
      form: {
        fabrication_type: '',
        automation_type: null,
        leaf_material: '',
        aluminum_color: '',
        aluminum_color_custom: '',
        glass_type: '',
        glass_thickness: '',
        glass_thickness_custom: '',
        sandblasting_type: '',
        polarized_type: '',
        general_notes: '',
        door_configuration: null
      },
      sandBlastingDesign: {},
      polarizedDesign: {},
      leafMaterialOptions: leafMaterialOptions,
      aluminumColorOptions: aluminumColorOptions,
      glassTypeOptions: glassTypeOptions,
      glassThicknessFullOptions: glassThicknessFullOptions,
      automationTypeOptions: automationTypeOptions,
      attachmentsModalShow: false,
      attachmentsModalTitle: '',
      attachmentsOrigen: ''
    }
  },
  mounted () {
    if (this.submital) {
      this.submitalForm.title = this.submital.title
      this.submitalForm.quantity = this.submital.quantity

      const documents = this.submital.documents
      if (documents.length > 0) {
        this.polarizedDesign = documents.find(d => d.key_field === 'polarized_type') || {}
        this.sandBlastingDesign = documents.find(d => d.key_field === 'sandblasting_type') || {}
      }
    }
    if (this.puerta) {
      this.form.fabrication_type = this.puerta.fabrication_type
      this.form.automation_type = this.puerta.automation_type
      this.form.leaf_material = this.puerta.leaf_material
      this.form.aluminum_color = this.puerta.aluminum_color
      this.form.aluminum_color_custom = this.puerta.aluminum_color_custom
      this.form.glass_type = this.puerta.glass_type
      this.form.glass_thickness = this.puerta.glass_thickness
      this.form.glass_thickness_custom = this.puerta.glass_thickness_custom
      this.form.sandblasting_type = this.puerta.sandblasting_type
      this.form.polarized_type = this.puerta.polarized_type
      this.form.general_notes = this.puerta.general_notes
      this.form.door_configuration = this.puerta.door_configuration
    }
  },
  computed: {
    ...mapState({
      puerta: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    ...mapGetters(['configuratorStepNumber']),
    glassThicknessOptions () {
      return this.glassThicknessFullOptions.filter(option => option.type.includes(this.form.glass_type))
                                           .map(option => ({ text: option.text, value: option.value }))
    }
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    updateSubmital () {
      this.submitalForm.quantity = this.submitalForm.quantity > 1 ? this.submitalForm.quantity : 1

      this.$emit('update-submital', this.submitalForm)
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.puerta[key])
    },
    updateStepNotes (notes) {
      this.form.general_notes = notes
    },
    openAttachmentsModal (origen) {
      if (origen === 'sanblasting') {
        this.attachmentsModalTitle = 'Adjuntar diseño de Sanblasting'
      } else if (origen === 'polarizado') {
        this.attachmentsModalTitle = 'Adjuntar diseño de Polarizado'
      }
      this.attachmentsOrigen = origen
      this.attachmentsModalShow = true
    },
    closeAttachmentsModal () {
      this.attachmentsModalShow = false
      this.attachmentsModalTitle = ''
      this.attachmentsOrigen = ''
    },
    handleFileAdded (form) {
      if (this.processing) { return }
      this.processing = true
      const resource = form.type == 'image' ? 'photos' : 'documents'
      let key = ''
      if (this.attachmentsOrigen === 'sanblasting') {
        key = 'sandblasting_type'
      } else if (this.attachmentsOrigen === 'polarizado') {
        key = 'polarized_type'
      }

      const body = form.type == 'image'
        ? { photo: { image: form.image, caption: form.caption, key_field: key } }
        : { document: { file: form.file, name: form.name, key_field: key } }

      this.$http.post(`/api/production/submitals/${this.submital.id}/${resource}`, body)
        .then((res) => {
          // console.log(res.data)
          if (resource === 'photos') {
            // HANDLE IMAGES?
          } else {
            const doc = res.data.document
            this.$store.commit('addSubmitalDocument', doc)
            const document = doc
            if (this.attachmentsOrigen === 'sanblasting') {
              this.sandBlastingDesign = document
            } else if (this.attachmentsOrigen === 'polarizado') {
              this.polarizedDesign = document
            }
          }
          this.closeAttachmentsModal()
        })
        .catch(e => {
          this.$emit('show-alert', {
            message: 'No fue posible agregar el archivo, intente de nuevo',
            variant: 'danger',
            time: 4000
          })
        })
        .finally(this.processing = false)
    },
    handleFileRemoved (file, origen) {
      if (this.processing) { return }
      this.processing = true
      this.$http.delete(`/api/production/submitals/${this.submital.id}/documents/${file.id}`)
        .then((resp) => {
          this.$store.commit('removeSubmitalDocument', file.id)
          if (origen === 'sanblasting') {
            this.sandBlastingDesign = {}
          } else if (origen === 'polarizado') {
            this.polarizedDesign = {}
          }
        })
        .catch(e => console.log(e))
        .finally(()=> {
          this.processing = false
        })
    },
    handleOnClickAttachment (doc) {
      if (this.processing) { return }
      this.processing = true
      this.$http.get(`/api/production/submitals/${this.submital.id}/documents/${doc.id}/download`)
        .then((resp) => {
          // console.log(resp.data)
          const link = document.createElement('a')
          link.href = resp.data
          link.download = doc.name
          link.click()
        })
        .catch(e => console.log(e))
        .finally(this.processing = false)
    }
  }
}
</script>